<template>
  <section class="prism included-features-section gray-bg !pb-4">
    <hr class="pricing-divider divider" />
    <Heading level="h2" size="h4" class="text-center !mb-6">{{ I18n.t("pricing.all_packages_include") }}</Heading>
    <div class="features-grid">
      <div :class="featureItemClasses">
        <RemoveBackgroundIcon />
        <p :class="featureTextClasses">
          {{ I18n.t("pricing.plans_features.max_quality_removals") }}
        </p>
      </div>
      <div :class="featureItemClasses">
        <NewBackgroundIcon />
        <p :class="featureTextClasses">
          {{ I18n.t("pricing.plans_features.magic_backgrounds") }}
        </p>
      </div>
      <div :class="featureItemClasses">
        <ShadowIcon />
        <p :class="featureTextClasses">
          {{ I18n.t("pricing.plans_features.add_shadows") }}
        </p>
      </div>
      <div :class="featureItemClasses">
        <NewBrushIcon />
        <p :class="featureTextClasses">
          {{ I18n.t("pricing.plans_features.erase_and_restore") }}
        </p>
      </div>
      <div :class="featureItemClasses">
        <BulkIcon />
        <p :class="featureTextClasses">
          {{ I18n.t("pricing.plans_features.bulk_editing") }}
        </p>
      </div>
      <div :class="featureItemClasses">
        <EmbedIcon />
        <p :class="featureTextClasses">
          {{ I18n.t("pricing.plans_features.all_plugins") }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { inject, computed } from "vue";
import { ShadowIcon, NewBrushIcon, NewBackgroundIcon, RemoveBackgroundIcon, EmbedIcon, BulkIcon, Heading } from "prism";

const I18n = inject("I18n");

const featureItemClasses = computed(() => "flex items-center w-full justify-center !py-2");
const featureTextClasses = computed(() => "text-typo text-sm font-semi-bold px-2 !mb-0 items-center");
</script>

<style scoped lang="scss">
.included-features-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.features-heading {
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 1.5rem;
  color: #0b1922;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem 1rem;
  width: 100%;
  max-width: 768px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
}

.gray-bg {
  background-color: #f1f3f4;
}

.pricing-divider {
  width: 100%;
  max-width: 768px;
  margin: 1.5rem 2.125rem;
}
</style>
